const apiDomain = window.SwimManagerConfig.apiDomain

import base_api from "./base_api.ts";

export default {
    /**
     * Allow passing in a URL for paginated queries
     * @param url
     * @returns {*}
     */
    getFinancialAccounts(url = null) {
        if (url == null) {
            url = route('api.club.web.v3.financial_accounts', {domain: apiDomain})
        }
        return base_api.get(url)
    },

    deleteFinancialAccount(financialAccountId) {
        return base_api.delete(route(
            'api.club.web.v3.financial_accounts.destroy',
            {domain: apiDomain, financial_account: financialAccountId}
        ))
    },

    createFinancialAccount(financialAccount) {
        return base_api.post(route(
            'api.club.web.v3.financial_accounts.store',
            {domain: apiDomain}
        ), financialAccount)

    },

    updateFinancialAccount(financialAccount) {
        return base_api.patch(route(
            'api.club.web.v3.financial_accounts.update',
            {domain: apiDomain, financial_account: financialAccount}
        ), financialAccount)
    },
}

